import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/componentes/ui/table';
import { Valor } from '@/componentes/valor';
import type { Sazonalidade } from '@/dados';
import { CHAVES, NOMES_MESES } from '@/telas/sazonalidade/meses';

import { Capitulo, Linha, NaoPreenchido } from './ficha';

/* O histórico mês a mês e a cobertura que ele declara.
 *
 * A cobertura importa mais que a soma: ela é a premissa que multiplica o
 * volume anual inteiro. Seis meses de histórico com cobertura de doze declara
 * metade do volume real. */
export function SazonalidadeDaEmpresa({ sazonalidade }: { sazonalidade: Sazonalidade | null }) {
  const meses = sazonalidade?.meses ?? null;
  const preenchidos = CHAVES.filter((chave) => meses?.[chave]);

  return (
    <Capitulo titulo="Sazonalidade" descricao="Histórico informado e o período que ele cobre.">
      {preenchidos.length === 0 ? (
        <NaoPreenchido>Nada preenchido na etapa Sazonalidade.</NaoPreenchido>
      ) : (
        <>
          <div className="grid">
            <Linha rotulo="Cobertura">
              <Valor valor={sazonalidade?.cobertura ?? 12} formato="inteiro" tamanho="apoio" />
              <span className="text-tinta-2 text-nota"> meses</span>
            </Linha>
          </div>
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead scope="col">Mês</TableHead>
                  <TableHead scope="col" className="text-right">Projetos</TableHead>
                  <TableHead scope="col" className="text-right">Faturamento</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {CHAVES.map((chave, indice) => (
                  <TableRow key={chave}>
                    <TableHead scope="row" className="font-normal">{NOMES_MESES[indice]}</TableHead>
                    <TableCell className="text-right">
                      <Valor valor={meses?.[chave]?.projetos} formato="inteiro" tamanho="apoio" />
                    </TableCell>
                    <TableCell className="text-right">
                      <Valor valor={meses?.[chave]?.valor} formato="moeda" tamanho="apoio" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </>
      )}
    </Capitulo>
  );
}
